// export const getPossibilities = (
//   timespanconfig,
//   checkForPossibilityAttributes = ["rasterVals"],
//   checkForPossibilityAttributesInverse = ["excludeInSlider"]
// ) => {
//   if (
//     !timespanconfig?.possibilities ||
//     timespanconfig.possibilities.length === 0
//   ) {
//     return [];
//   }
//   return timespanconfig.possibilities.filter((possibility) => {
//     return (
//       (!checkForPossibilityAttributes ||
//         checkForPossibilityAttributes.reduce((acc, current) => {
//           return acc && !!possibility[current];
//         }, true)) &&
//       (!checkForPossibilityAttributesInverse ||
//         checkForPossibilityAttributesInverse.reduce((acc, current) => {
//           return acc && !possibility[current];
//         }, true))
//     );
//   });
// };

export const getPossibilities = (
  timespanconfig,
  // checkForPossibilityAttributes = [],
  checkForPossibilityAttributesInverse = ["excludeInSlider"]
) => {
  if (
    !timespanconfig?.possibilities ||
    timespanconfig.possibilities.length === 0
  ) {
    return [];
  }

  // Keep all possibilities unless an inverse-filter list is provided.
  if (!checkForPossibilityAttributesInverse) {
    return timespanconfig.possibilities;
  }

  return timespanconfig.possibilities.filter((possibility) => {
    return checkForPossibilityAttributesInverse.every(
      (attribute) => !possibility[attribute]
    );
  });
};

/*
let decimalPlaces = Nachkommastellen;
  if(possibilities?.[0].decimalPlaces !== undefined){
    decimalPlaces = Number(possibilities[0].decimalPlaces);
  } else if(allTimespans?.[0]?.possibilities?.[0]?.Nachkommastellen) {
    decimalPlaces = Number(allTimespans[0].possibilities[0].Nachkommastellen);
  } 
  */
export const getTimespansFromCommunicationStore = (
  CommunicationStore,
  filterOutNoPossibilities = true,
  // checkForPossibilityAttributes = [],
  checkForPossibilityAttributesInverse = ["excludeInSlider"],
  decimalPlacesDefault = 0,
  includeAll = false
) => {
  const Level1 = "Zeitraum"; // timespan
  const Level2 = "Szenario"; // projection szenario
  const getFilterConfig = CommunicationStore.getMessagesToID({
    to: "filterAccess",
  })?.message;
  let current = null;
  let all = [];
  let allSzenarios = [];
  let szenario = null;
  let decimalPlaces = null;
  if (getFilterConfig) {
    const { items: zeitraeume, index: zeitraumindex } = getFilterConfig(Level1);

    // Only build the full list if explicitly requested.
    if (includeAll) {
      all = zeitraeume.map((zeitraum) => {
        return {
          ...zeitraum,
          possibilities: getPossibilities(
            zeitraum,
            // checkForPossibilityAttributes,
            checkForPossibilityAttributesInverse
          ),
        };
      });

      if (filterOutNoPossibilities) {
        all = all.filter((zeitraum) => {
          if (zeitraum?.possibilities && zeitraum.possibilities.length > 0) {
            return true;
          }
          return false;
        });
      }
    }

    if (zeitraumindex !== -1) {
      current = zeitraeume[zeitraumindex];

      if (
        current?.possibilities?.[0] &&
        "Nachkommastellen" in current.possibilities[0]
      )
        decimalPlaces = current.possibilities[0].Nachkommastellen;

      if (current?.projection) {
        const { items: szenarios, index: szenarioIndex } =
          getFilterConfig(Level2);
        if (includeAll) {
          allSzenarios = szenarios.concat([]);
        }
        if (szenarioIndex !== -1) {
          szenario = szenarios[szenarioIndex];
        }
      }
    }
    // // Detect whether the currently selected timespan is a "change" (Änderung zu 1971-2000)
    // const isChangeMode = Boolean(
    //   current &&
    //     (current.excludeInSlider === true ||
    //       (current.label && String(current.label).includes("zu 1971-2000")))
    // );

    return {
      current,
      all,
      szenario,
      allSzenarios,
      decimalPlaces:
        decimalPlaces !== null ? decimalPlaces : decimalPlacesDefault,
      // isChangeMode,
    };
  }
  return {};
};

export const getSzenarioMap = (possibilities = [], szenarios = []) => {
  const Level2 = "Szenario"; // projection szenario
  let ret = {};
  if (szenarios.length) {
    szenarios.forEach((szenario) => {
      const actualPossibilities = possibilities.filter(
        (possibility) => possibility.constraints[Level2] === szenario.label
      );
      if (actualPossibilities.length > 0)
        ret[szenario.label] = actualPossibilities;
    });
  } else {
    possibilities.forEach((possibillity) => {
      const index = possibillity.constraints[Level2];

      if (!ret[index]) {
        ret[index] = [];
      }
      ret[index].push(possibillity);
    });
  }
  return ret;
};

// TODO: check here if a reset to full Niedersachsen is needed
export const getSelectionGraphic = (CommunicationStore) => {
  const message = CommunicationStore.getMessagesToID({
    toId: "selectionGraphic",
  })?.message;
  // if graphic is null => its a reset to full Niedersachsen
  if (!message || !message.graphic) {
    return {
      source: {
        displayText: "Auswahl",
        article: "neutral",
        displayAttribute: "",
        name: "Bundesland",
      },
      name: "Bundesland",
      entityTypeDisplayText: "Bundesland",
      displayText: "Niedersachsen",
      article: "neutral",
    };
  }

  const {
    source = {
      displayText: "Auswahl",
      article: "neutral",
      displayAttribute: "",
      name: "Bundesland",
    },
    entity,
    graphic,
    from /* which widget did set this */,
  } = message;
  return {
    raw: message,
    from,
    entity,
    source,
    name: source.name,
    article: source.article || "female",
    graphic,
    entityTypeDisplayText: source?.displayText || "Auswahl",
    displayText: entity?.[source.displayAttribute] || "",
  };
};

export const getUnits = (CommunicationStore) => {
  const message = CommunicationStore.getMessagesToID({
    toId: "shownLayers",
  })?.message;

  return message?.layerInfos[message.layerInfos.length - 1]?.metaData?.units;
};

export const articlemap = {
  female: {
    genitiv: "der",
    nominativ: "die",
    akkusativ: "die",
  },
  male: {
    genitiv: "des",
    nominativ: "der",
    akkusativ: "den",
  },
  neutral: {
    genitiv: "des",
    nominativ: "das",
    akkusativ: "das",
  },
};
